import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TopdownAdjustmentNewComponent } from './topdown-adjustment-new.component';

const routes: Routes = [{ path: '', component: TopdownAdjustmentNewComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TopdownAdjustmentNewRoutingModule { }
